import React, { useState, useEffect } from 'react';

import Api from 'utils/api';

import styles from './MachineGroupTab.module.css';

const MachineGroupTab = () => {
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);

  // 모달 및 폼 상태
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [formData, setFormData] = useState({ machineGroupId: null, machineGroupName: '' });

  useEffect(() => {
    fetchGroupList();
  }, []);

  // 1. 리스트 조회 (GET)
  const fetchGroupList = async () => {
    setLoading(true);
    const data = await Api.get('/machine/group');
    if (data?.machineGroupList) {
      setGroups(data.machineGroupList)
    } else {
      setGroups([]);
    }
    setLoading(false);

  };

  const handleOpenModal = (mode, data = null) => {
    setIsEditMode(mode === 'edit');
    setFormData(data ? { ...data } : { machineGroupId: null, machineGroupName: '' });
    setIsModalOpen(true);
  };

  // 2. 저장 로직 (POST)
  const handleSave = async () => {
    if (!formData.machineGroupName.trim()) {
      return alert("그룹 이름을 입력해주세요.");
    }

    try {
      let response;

      if (isEditMode) {
        const requestBody = {
          machineGroupId: formData.machineGroupId,
          machineGroupName: formData.machineGroupName
        };

        response = await Api.patch('/machine/group', requestBody);
      } else {
        const requestBody = {
          machineGroupName: formData.machineGroupName
        }

        response = await Api.post('/machine/group', requestBody);
      }

      if (!response) return;

      alert(isEditMode ? "수정이 완료되었습니다." : "등록이 완료되었습니다.");
      setIsModalOpen(false);
      fetchGroupList();
      
    } catch (error) {
      console.error("통신 오류:", error);
      alert("서버와 통신 중 오류가 발생했습니다.");
    }

  };

  // 3. 삭제 로직 (DELETE)
  const handleDelete = async (id) => {
    if (!window.confirm("이 그룹를 삭제하시겠습니까?")) return;

    const data = await Api.delete(`/machine/group?machineGroupId=${id}`)

    if (data.code === 200) {
      alert("삭제가 완료되었습니다.");
      fetchGroupList(); // 삭제 후 목록 최신화
    } else {
      alert(`삭제 실패: ${data.message || '오류가 발생했습니다.'}`);
    }

  };

  if (loading) return <div className={styles.centerMsg}>그룹 정보를 불러오는 중...</div>;

  return (
    <div className={styles.container}>
      <div className={styles.topBar}>
        <div className={styles.countInfo}>등록된 그룹 <span className={styles.countNumber}>{groups.length}</span></div>
        <button className={styles.addBtn} onClick={() => handleOpenModal('add')}>+ 그룹 등록</button>
      </div>

      <div className={styles.cardGrid}>
        {groups.map((f) => (
          <div key={f.machineGroupId} className={styles.groupCard}>
            <div className={styles.cardHeader}>
              <div>
                <h3 className={styles.groupName}>{f.machineGroupName}</h3>
              </div>
            </div>

            <div className={styles.cardFooter}>
              <button className={styles.editBtn} onClick={() => handleOpenModal('edit', f)}>수정</button>
              <button className={styles.deleteBtn} onClick={() => handleDelete(f.machineGroupId)}>삭제</button>
            </div>
          </div>
        ))}
      </div>

      {isModalOpen && (
        <div className={styles.modalOverlay}>
          <div className={styles.modalContent}>
            <div className={styles.modalHeader}>
              <h3>{isEditMode ? '그룹 수정' : '새 그룹 등록'}</h3>
              <button className={styles.closeBtn} onClick={() => setIsModalOpen(false)}>✕</button>
            </div>
            <div className={styles.modalBody}>
              <div className={styles.formContainer}>
                <div className={styles.inputGroup}>
                  <label>그룹 명칭</label>
                  <input
                    name="machineGroupName"
                    value={formData.machineGroupName}
                    onChange={(e) => setFormData({ ...formData, machineGroupName: e.target.value })}
                    className={styles.modalInput}
                    placeholder="예: 그룹명"
                    autoFocus
                  />
                </div>
              </div>
            </div>
            <div className={styles.modalFooter}>
              <button className={styles.cancelBtn} onClick={() => setIsModalOpen(false)}>취소</button>
              <button className={styles.saveBtn} onClick={handleSave}>저장하기</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MachineGroupTab;